class ProductRecommendations extends HTMLElement {
  constructor() {
    super()

    this.sectionId = this.dataset.sectionId

    const initializeCarousel = () => {
      const productGrid = this.querySelector('.product-grid')
      const nextButton = this.querySelector(`.js-product-carousel-next-${this.sectionId}`)
      const prevButton = this.querySelector(`.js-product-carousel-previous-${this.sectionId}`) 

      new Swiper(productGrid, {
        slidesPerView: "auto",
        mouseDragging: true,
        grabCursor: true,
        keyboard: {
          enabled: true
        },
        mousewheel: {
          forceToAxis: true
        },
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        }
      })
    }

    // Only loads the recommendations when the element is in the viewport
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return
      observer.unobserve(this)

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div')
          html.innerHTML = text
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML
          }

          initializeCarousel()
        })
        .catch((e) => {
          console.error(e)
        })
    }

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this)

    if (Shopify.designMode) {
      document.addEventListener("shopify:section:select", () => initializeCarousel())
    }
  }
}

customElements.define('product-recommendations', ProductRecommendations)